import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { createUseStyles, Chip, SelectWrapper } from '@Sage/hoi-poi-ui';
import AgentsIcon from "../../../CopilotSidebar/components/AgentsIcon/Agents";
import { CopilotContext } from "../../../Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotAgentSwitcher');
var _ref2 = /*#__PURE__*/React.createElement(AgentsIcon, null);
const AgentSwitcher = _ref => {
  let {
    chatId
  } = _ref;
  const [state, setState] = useState({
    showPopover: false
  });
  const popoverRef = useRef(null);
  const classes = useStyles();
  const {
    copilotAgents,
    setActiveAgent,
    getChatState,
    defaultAgent
  } = useContext(CopilotContext);
  const chatState = useMemo(() => getChatState({
    chatId
  }), [getChatState, chatId]);
  const {
    activeAgent
  } = chatState;
  const currentAgent = useMemo(() => activeAgent || defaultAgent, [activeAgent, defaultAgent]);
  const onChange = useCallback(payload => {
    const newActiveAgent = copilotAgents.find(agent => agent.name === payload.value);
    if (newActiveAgent) {
      setActiveAgent({
        chatId,
        agent: newActiveAgent
      });
    }
    setState(state => _objectSpread(_objectSpread({}, state), {}, {
      showPopover: false
    }));
  }, [chatId, copilotAgents, setActiveAgent]);
  const chipProps = useMemo(() => ({
    icon: _ref2,
    isUnfolded: true,
    isOutlined: true,
    onClick: () => setState(state => _objectSpread(_objectSpread({}, state), {}, {
      showPopover: true
    })),
    children: /*#__PURE__*/React.createElement("span", {
      className: classes.chipContent
    }, /*#__PURE__*/React.createElement(AgentsIcon, {
      className: classes.chipIcon
    }), /*#__PURE__*/React.createElement("span", null, (currentAgent === null || currentAgent === void 0 ? void 0 : currentAgent.label) || (currentAgent === null || currentAgent === void 0 ? void 0 : currentAgent.name) || (currentAgent === null || currentAgent === void 0 ? void 0 : currentAgent.description)))
  }), [currentAgent, classes.chipContent, classes.chipIcon]);
  const selectWrapperProps = useMemo(() => ({
    value: currentAgent === null || currentAgent === void 0 ? void 0 : currentAgent.name,
    onChange,
    options: copilotAgents.map(agent => ({
      label: (agent === null || agent === void 0 ? void 0 : agent.label) || (agent === null || agent === void 0 ? void 0 : agent.name),
      value: agent.name
    })),
    children: /*#__PURE__*/React.createElement(Chip, chipProps),
    getPopoverContentRef: ref => {
      if (ref) popoverRef.current = ref;
    },
    overrides: {
      Popover: {
        root: {
          visible: state.showPopover,
          placement: 'topLeft'
        }
      }
    }
  }), [currentAgent, chipProps, copilotAgents, onChange, state.showPopover]);
  const handleClickOutside = useCallback(event => {
    var _popoverRef$current, _popoverRef$current$c;
    if (!((_popoverRef$current = popoverRef.current) !== null && _popoverRef$current !== void 0 && (_popoverRef$current$c = _popoverRef$current.contains) !== null && _popoverRef$current$c !== void 0 && _popoverRef$current$c.call(_popoverRef$current, event.target))) {
      setState(state => _objectSpread(_objectSpread({}, state), {}, {
        showPopover: false
      }));
    }
  }, []);
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);
  if (selectWrapperProps.options.length === 0) return null;
  return /*#__PURE__*/React.createElement(SelectWrapper, selectWrapperProps);
};
export default /*#__PURE__*/memo(AgentSwitcher);